import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { CustomSvgIcon } from 'crazyEditor/components/EditorUI/BaseUI/index';
import * as Colors from 'material-ui/styles/colors';
import {HoverMixin} from '../../../../../shared/helpers/mixins';
import reactMixin from 'react-mixin';
import CheckCircle from 'material-ui/svg-icons/action/check-circle';
import Paper from 'material-ui/Paper';
import {dollar} from 'shared/icons';

@reactMixin.decorate(HoverMixin)
export default class SelectableBox extends Component {
  state = {};
  render() {
    const {children, style, selectable, variation} = this.props;
    let {color, zDepth, selected} = this.props;
    let {hovered} = this.state;
    selected &= selectable;
    hovered &= selectable;
    let borderColor;
    if (hovered) {
      zDepth += 2;
    }
    if (hovered && !selected) {
      color = Colors.grey500;
      borderColor = 'transparent';
    } else if (selected) {
      borderColor = color;
    }

    return (
      <Paper
        {...{onClick: selectable && this.props.onClick}}
        style={{...style, position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: selectable ? 'pointer' : null}}
        onMouseEnter = {this.onMouseEnter.bind(this)}
        onMouseLeave = {this.onMouseLeave.bind(this)}
        zDepth={zDepth}
      >
        {children}
        {
          (selected || hovered)
            ?
            <div
              style={{position: 'absolute', pointerEvents: 'none', top: 0, left: 0, height: 'calc(100% - 8px)', width: 'calc(100% - 8px)', border: '4px solid ' + borderColor}}
            >
              <CheckCircle
                color = {color}
                style= {{position: 'absolute', top: 10, left: 10, borderRadius: '50%', borderColor: Colors.white, borderWidth: 2, backgroundColor: Colors.white}}
              />
              {
                variation === 2 &&
                <CustomSvgIcon
                  color={selected ? color : Colors.grey500}
                  style={{
                    position: 'absolute',
                    top: 10,
                    right: 10,
                    borderRadius: '50%',
                    borderColor: Colors.white,
                    borderWidth: 2,
                    backgroundColor: Colors.white
                  }}
                  path={dollar}
                />
              }
            </div>
            :
            null
        }
      </Paper>
    );
  }
}

SelectableBox.propTypes = {
  color: PropTypes.string,
  borderType: PropTypes.oneOf(['inside', 'outside']),
  zDepth: PropTypes.number.isRequired,
  selectable: PropTypes.bool.isRequired,
};

SelectableBox.defaultProps = {
  color: Colors.lightGreen600,
  selectable: true,
  zDepth: 2,
};